(function () {
	'use strict';

	//each api url must not be starts with '/'
	angular.module('dcApp').constant('API_BASE_URL_BACKEND', '/service/');
	angular.module('dcApp').constant('DOC_URL', '/doc');
})();
